import React, { useState } from "react";
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    StyleSheet,
    Modal
} from "react-native";

import { Ionicons } from "@expo/vector-icons";
import Config from "../../Config";
import axios from "axios";
import AntDesign from '@expo/vector-icons/AntDesign';
import NumberFormat from "./NumberFormat";
import {RFValue} from "react-native-responsive-fontsize";
import AsyncStorage from "@react-native-async-storage/async-storage";

import * as Linking from "expo-linking";
import toast from "./Toast";

const DiscountModal = ({ isVisible, onClose, courseName, courseId ,price , navigation }) => {
    const [code, setCode] = useState("");
    const [discountInfo, setDiscountInfo] = useState(null);
    const [error, setError] = useState(null);
    const [lastprice, setLastprice] = useState(price);

    const checkDiscount = async () => {
        try {

            let token = await AsyncStorage.getItem('token');
            let formData = new FormData();
            formData.append('code', code);
            formData.append('course_id', courseId);

            let res = await axios.post(
                `${Config.api}/user/checkdiscount`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );
            console.log(res.data);
            if (res.data.code === 1) {
                setDiscountInfo(res.data.discount);
                setError(null);

                setLastprice(res.data.price);
            } else {

                setDiscountInfo(null);
                setError(res.data.error);
                setLastprice(price);
            }
        } catch (err) {
            console.log(err);
            setError("خطا در بررسی کد تخفیف");
        }
    };



    const handlePurchase = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let formData = new FormData();
            formData.append('code', code);
            formData.append('course_id', courseId);


            let res = await axios.post(
                `${Config.api}/user/registercourse/${courseId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );

            console.log(res.data);
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
              setError(res.data.error)
            }

            if(res.data.gateway == 0){
                toast('شما با موفقیت در دوره ثبت نام کردید');
                navigation.navigate('Course',{course_id:res.data.courses.id});
                return false;
            }else{
                Linking.openURL(res.data.gateway);
            }
        } catch (err) {
            console.log(err);
            setError(err)
        }
    };

    return (
        <Modal   animationType="fade" visible={isVisible}>
            <View style={styles.modalContent}>


              <TouchableOpacity   style={{
                  position: "absolute",
                  left : 10,
                  top: 10,
              }} onPress={()=>onClose(false)}>
                  <AntDesign

                      name="closecircleo"
                      size={24}
                      color={Config.secondcolor}
                      onPress={() => onClose(false)}
                  />
              </TouchableOpacity>

                <Text style={styles.modalTitle}>{courseName}</Text>

                <TextInput
                    style={styles.input}
                    placeholder="کد تخفیف"
                    value={code}
                    onChangeText={setCode}
                />
                <View style={{flexGrow : 2}}>
                    <TouchableOpacity onPress={checkDiscount} style={styles.checkButton}>
                        <Text style={styles.buttonText}>بررسی کد تخفیف</Text>
                    </TouchableOpacity>

                    {discountInfo && (
                        <View style={styles.discountInfo}>
                            <Text>نام تخفیف: {discountInfo.name}</Text>
                            <Text>درصد تخفیف: {discountInfo.percent}%</Text>
                        </View>
                    )}

                    {error && <Text style={styles.errorText}>{error}</Text>}
                </View>







                {lastprice == 0 ?
                    <>
                        <Text style={styles.price}>
                            رایگان با کد تخفیف صد در صدی !
                        </Text>
                        <TouchableOpacity onPress={handlePurchase} style={styles.purchaseButton}>
                            <Text style={styles.buttonText}>ثبت نام</Text>
                            <Ionicons name="arrow-back" size={24} color="white" />
                        </TouchableOpacity>
                    </>
                    :
                    <>
                        <Text style={styles.price}>
                            <NumberFormat number={lastprice} />
                            {` `} تومان
                        </Text>
                        <TouchableOpacity onPress={handlePurchase} style={styles.purchaseButton}>
                            <Text style={styles.buttonText}>خرید و اتصال به درگاه بانکی</Text>
                            <Ionicons name="arrow-back" size={24} color="white" />
                        </TouchableOpacity>
                    </>
                }

            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalContent: {
        backgroundColor: "white",
        padding: 20,
        borderRadius: 10,
        flex : 1
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: "bold",
        marginBottom: 20,
        textAlign: "center",
        fontFamily : 'ykb' ,
    },
    input: {
        borderWidth: 1,
        borderColor: "#ccc",
        borderRadius: 5,
        padding: 10,
        marginBottom: 10,
        fontFamily : 'ykb' ,
    },
    checkButton: {
        backgroundColor: Config.secondcolor,
        padding: 10,
        borderRadius: 5,
        marginBottom: 10,
        alignItems: "center"
    },
    purchaseButton: {
        backgroundColor: Config.maincolor,
        padding: 10,
        borderRadius: 5,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    },
    buttonText: {
        color: "white",
        marginLeft: 10,
        fontFamily : 'ykb' ,
    },
    discountInfo: {
        marginVertical: 10,
        backgroundColor: "#e0ffe0",
        padding: 10,
        borderRadius: 5,
        fontFamily : 'ykb' ,
    },
    errorText: {
        color: "red",
        textAlign: "center",
        marginVertical: 10,
        fontFamily : 'ykb' ,

    },
    price : {
        fontFamily : 'ykb' ,
        fontSize : RFValue(15),
        color : '#0D1134',
        marginVertical : RFValue(10),
        width : '100%',
        textAlign: "center"
    },
});

export default DiscountModal;
